export enum eOrderStates{
      'Creado' = 1,
      'Solicitud De Cancelación' = 2,
      'Cancelado' = 3,
      'En Espera de stock' = 4,
      'En Preparación' = 5,
      'Gestión Completada' = 6
}